export default "__VITE_ASSET__659773c8__"